module.exports = __webpack_public_path__ + "static/symbiosis_board_large.8689fe8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/boards/symbiosis_board_large.jpg
// module id = 632
// module chunks = 123502253449456